import React, { lazy, Suspense } from 'react';
import '../styles/globals.css';
import { ThemeProvider } from '#AdminPanelFrontend/components/theme-provider';
import { MenuProvider } from '#AdminPanelFrontend/contexts/MenuContext';
import App from '#AdminPanelFrontend/authorized/App';

const Authorized: React.FC = () => {
	return (
		<ThemeProvider defaultTheme="system" storageKey="ui-theme">
			<MenuProvider>
				<App />
			</MenuProvider>
		</ThemeProvider>
	);
};

export default Authorized;
